import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  initials: 'LT',
  name: 'L.T.',
  role: 'Dance Teacher | New York, USA',
  text: '"The jazz classes completely transformed how my students experience technique. The cues are already written — I just teach them. My classes feel more professional than they ever have before."'
}, {
  initials: 'CR',
  name: 'C.R.',
  role: 'Dance Instructor | Melbourne, Australia',
  text: '"The emergency classes have saved me more times than I can count in my first month. Before this, a last-minute request would send me into a panic. Now I just open the backup library and teach a fully structured session."'
}, {
  initials: 'DG',
  name: 'D.G.',
  role: 'Dance Teacher | Toronto, Canada',
  text: '"I go through the key cues before every session and walk in knowing exactly what I\'m going to say. The cueing library is something I use every single week — it\'s become completely essential."'
}, {
  initials: 'SM',
  name: 'S.M.',
  role: 'Dance Instructor | London, UK',
  text: '"The musical theatre classes were a total revelation. My students talk about those sessions for weeks. They feel like a real performance experience — not just a class."'
}, {
  initials: 'AM',
  name: 'A.M.',
  role: 'Dance Teacher | Dublin, Ireland',
  text: '"The progress tracker gave me back my confidence with mixed-level groups. Before this I always felt uncertain when I had dancers at very different stages in the same class. Now I have a clear system — and my students can actually see how far they\'ve come."'
}];
export function ExtendedTestimonials() {
  return <section className="py-24 px-4 bg-dark-card" data-id="element-65">
      <div className="max-w-6xl mx-auto" data-id="element-66">
        <div className="text-center mb-16" data-id="element-67">
          <h2 className="text-3xl md:text-5xl font-serif font-bold" data-id="element-68">
            What Dance Teachers Who Already Have the Library Are Saying
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-69">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-black border border-dark-border p-8 rounded-2xl relative ${i === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-70">
              <Quote className="absolute top-6 right-6 text-gold/10" size={48} data-id="element-71" />

              <div className="flex gap-1 text-gold mb-6" data-id="element-72">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-73" />)}
              </div>

              <p className="text-gray-300 italic mb-8 relative z-10 leading-relaxed" data-id="element-74">
                {t.text}
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-75">
                <div className="w-12 h-12 rounded-full bg-gold-gradient flex items-center justify-center text-black font-bold text-lg" data-id="element-76">
                  {t.initials}
                </div>
                <div data-id="element-77">
                  <div className="font-bold text-white" data-id="element-78">{t.name}</div>
                  <div className="text-xs text-gold-light" data-id="element-79">{t.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}